module.exports = __webpack_public_path__ + "static/mf-a90d6abb5d7c3eccfdbb80507f5c6b51.jpg";